import { render, staticRenderFns } from "./EvaluationSkillGravityPage.vue?vue&type=template&id=87ce2618&"
import script from "./EvaluationSkillGravityPage.vue?vue&type=script&lang=js&"
export * from "./EvaluationSkillGravityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports